import { createPersistence } from '@/shared/lib/store';

const { createAccessor, defineMutation } = createPersistence('affecting-factors-');
const storage = createAccessor();

const state = {
  policyholder: {
    isVehicleOwner: storage.get('policyholder-is-vehicle-owner', false),
    taxNumber: null,
    birthday: null,
  },
  vehicle: {
    youngestDriverAge: storage.get('vehicle-youngest-driver-age', null),
    ownerIsPolicyholder: storage.get('vehicle-owner-is-policyholder', false),
    ownerBirthday: storage.get('vehicle-owner-birthday', null),
  },
  availableFactors: storage.get('available-factors', []),
};

const mutations = {
  SET_POLICYHOLDER_IS_VEHICLE_OWNER: defineMutation('policyholder.isVehicleOwner', 'policyholder-is-vehicle-owner', false),
  SET_AFFECTING_FACTORS_POLICYHOLDER_TAX_NUMBER(state, taxNumber) {
    state.policyholder.taxNumber = taxNumber;
  },
  SET_AFFECTING_FACTORS_POLICYHOLDER_BIRTHDAY: defineMutation('policyholder.birthday', 'policyholder-birthday', null),

  SET_AFFECTING_FACTORS_VEHICLE_YOUNGEST_DRIVER_AGE: defineMutation('vehicle.youngestDriverAge', 'vehicle-youngest-driver-age', null),
  SET_AFFECTING_FACTORS_VEHICLE_OWNER_IS_POLICYHOLDER: defineMutation('vehicle.ownerIsPolicyholder', 'vehicle-owner-is-policyholder', null),
  SET_AFFECTING_FACTORS_VEHICLE_OWNER_BIRTHDAY: defineMutation('vehicle.ownerBirthday', 'vehicle-owner-birthday', null),
  SET_AFFECTING_FACTORS_AVAILABLE_FACTORS(state, factors) {
    const merged = new Set([...state.availableFactors, ...factors]);
    state.availableFactors = [...merged];
    storage.set('available-factors', state.availableFactors);
  },
  REMOVE_AFFECTING_FACTOR(state, factor) {
    state.availableFactors = state.availableFactors.filter(f => f !== factor);
    storage.set('available-factors', state.availableFactors);
  },
  CLEAR_ALL(state) {
    state.policyholder.isVehicleOwner = false;
    state.policyholder.taxNumber = null;
    state.policyholder.birthday = null;

    state.vehicle.youngestDriverAge = null;
    state.vehicle.ownerIsPolicyholder = false;
    state.vehicle.ownerBirthday = null;
    state.availableFactors = [];

    storage.clear();
  },
};

const actions = {
  setAffectingFactorsPolicyholderIsVehicleOwner({ commit }, isOwner) {
    commit('SET_POLICYHOLDER_IS_VEHICLE_OWNER', isOwner);
  },
  setAffectingFactorsPolicyholderTaxNumber({ commit }, taxNumber) {
    commit('SET_AFFECTING_FACTORS_POLICYHOLDER_TAX_NUMBER', taxNumber);
  },
  setAffectingFactorsPolicyholderBirthday({ commit }, policyholderBirthday) {
    commit('SET_AFFECTING_FACTORS_POLICYHOLDER_BIRTHDAY', policyholderBirthday);
  },

  setAffectingFactorsVehicleYoungestDriverAge({ commit }, vehicleYoungestDriverAge) {
    commit('SET_AFFECTING_FACTORS_VEHICLE_YOUNGEST_DRIVER_AGE', vehicleYoungestDriverAge);
  },
  setAffectingFactorsVehicleOwnerIsPolicyholder({ commit }, vehicleOwnerIsPolicyholder) {
    commit('SET_AFFECTING_FACTORS_VEHICLE_OWNER_IS_POLICYHOLDER', vehicleOwnerIsPolicyholder);
  },
  setAffectingFactorsVehicleOwnerBirthday({ commit }, vehicleOwnerBirthday) {
    commit('SET_AFFECTING_FACTORS_VEHICLE_OWNER_BIRTHDAY', vehicleOwnerBirthday);
  },
  setAffectingFactorsAvailableFactors({ commit }, factors) {
    const factorsArray = Array.isArray(factors) ? factors : [factors];
    commit('SET_AFFECTING_FACTORS_AVAILABLE_FACTORS', factorsArray);
  },
  removeAffectingFactor({ commit }, factor) {
    commit('REMOVE_AFFECTING_FACTOR', factor);
  },

  clear({ commit }) {
    commit('CLEAR_ALL');
  },
};

const getters = {
  getAffectingFactorsPolicyholderIsVehicleOwner: state => state.policyholder.isVehicleOwner,
  getAffectingFactorsPolicyholderTaxNumber: state => state.policyholder.taxNumber,
  getAffectingFactorsPolicyholderBirthday: state => state.policyholder.birthday,
  getAffectingFactorsVehicleYoungestDriverAge: state => state.vehicle.youngestDriverAge,
  getAffectingFactorsVehicleOwnerIsPolicyholder: state => state.vehicle.ownerIsPolicyholder,
  getAffectingFactorsVehicleOwnerBirthday: state => state.vehicle.ownerBirthday,
  getAffectingFactorsAvailableFactors: state => state.availableFactors,
  hasAvailableAffectingFactor: state => factor => state.availableFactors.includes(factor),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
